import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import BlogManage from './pages/BlogManage';
import BlogEditorJS from './pages/BlogEditorJS';
import EventsManage from './pages/EventsManage';
import AnnouncementsManage from './pages/AnnouncementsManage';
import BannersManage from './pages/BannersManage';
import CategoriesManage from './pages/CategoriesManage';
import UsersManage from './pages/UsersManage';
import Settings from './pages/Settings';
import Layout from './components/Layout';
import './App.css';

function AppContent() {
    const { isAuthenticated, user, loading } = useAuth();

    useEffect(() => {
        const savedTheme = localStorage.getItem('theme') || 'light';
        document.documentElement.setAttribute('data-theme', savedTheme);
    }, []);

    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner"></div>
                <p>Cargando...</p>
            </div>
        );
    }

    return (
        <Router>
            <Routes>
                <Route
                    path="/login"
                    element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />}
                />
                
                <Route path="/" element={isAuthenticated ? <Layout /> : <Navigate to="/login" replace />}>
                    <Route index element={<Navigate to="/dashboard" replace />} />
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="blog" element={<BlogManage />} />
                    <Route path="blog/new" element={<BlogEditorJS />} />
                    <Route path="blog/edit/:id" element={<BlogEditorJS />} />
                    <Route path="events" element={<EventsManage />} />
                    <Route path="announcements" element={<AnnouncementsManage />} />
                    <Route path="banners" element={<BannersManage />} />
                    <Route path="categories" element={<CategoriesManage />} />
                    <Route 
                        path="users" 
                        element={user?.role === 'admin' ? <UsersManage /> : <Navigate to="/dashboard" replace />} 
                    />
                    <Route path="settings" element={<Settings />} />
                </Route>
                
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </Router>
    );
}

function App() {
    return (
        <AuthProvider>
            <AppContent />
        </AuthProvider>
    );
}

export default App;
